export default "__VITE_ASSET__DIjD4Yah__"